import hyperdom from 'hyperdom'
import range from 'lowscore/range.js'

export default function (options) {
  function twoDigit (value) {
    return ('0' + value.toString()).substr(-2)
  }
  return <select class='o-form-item__txt-input' binding={options.binding}>
    <option value='Any'>Anytime</option>
    {
      range(0, 24).map(function (hour) {
        return <option value={twoDigit(hour) + ':00'}>{twoDigit(hour)}:00</option>
      })
    }
  </select>
}
